import React from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'
import OneColWrapper from '../technical/OneColWrapper'

const QuoteBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      <OneColWrapper
        block={block}
        className={`quote-block ${
          block.quote_small === true ? 'quote-small' : ''
        } ${block.quote_color ? block.quote_color : ''} ${
          className ? className : ''
        }`}
      >
        <blockquote data-rellax-center={true} data-rellax-speed={1}>
          <p>{block.quote}</p>
          {block.author?.length > 0 && (
            <footer>
              {block.image?.filename?.length > 0 && (
                <Image imageWidth="100" imageHeight="100" image={block.image} />
              )}
              <b>{block.author}</b> {block.position}
            </footer>
          )}
        </blockquote>
      </OneColWrapper>
    </SbEditable>
  )
}

export default QuoteBlock
